module.exports = __webpack_public_path__ + "static/img/appicon4.681ad93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/appicon4.png
// module id = JbNB
// module chunks = 0